import React from "react";
import PropTypes from "prop-types";
import { Form, Button } from "semantic-ui-react";
import CustomSearch from "../../CustomSearch";
import _ from "lodash";

class ActividadesDisponibles extends React.Component {
  state = {
    value: ""
  };

  handleButtonClick = () => {
    this.props.handleButtonClick(this.state.value);
    this.setState({ value: "" });
  };

  handleSelection = value => this.setState({ value });

  render() {
    return (
      <Form.Group>
        <CustomSearch
          id="buscadorActividad"
          name="buscadorActividad"
          type="text"
          placeholder="Nombre de actividad"
          datosBusqueda={this.props.datosBusqueda}
          onSelect={this.handleSelection}
          icon="search"
          value={this.state.value}
        />
        <Button
          disabled={_.isEmpty(this.state.value)}
          basic
          type="button"
          color="pink"
          onClick={this.handleButtonClick}
        >
          Añadir Actividad
        </Button>
      </Form.Group>
    );
  }
}

ActividadesDisponibles.propTypes = {
  handleButtonClick: PropTypes.func,
  datosBusqueda: PropTypes.array.isRequired
};

export default ActividadesDisponibles;



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/asignacionActividades/ActividadesDisponibles.jsx